<div class="min-h-screen w-full bg-background overflow-x-hidden">
  <app-app-bar />
  @if (settingsService.settingsLoaded() && !settingsService.isRestaurantOpen()) {
  <div class="w-full bg-rose-500/10 border-b border-rose-500/20 backdrop-blur-md px-4 py-2.5 transition-all animate-in fade-in slide-in-from-top-2 duration-300">
    <div class="max-w-5xl mx-auto flex items-center justify-between gap-3 text-xs sm:text-sm">
      <div class="flex items-center gap-2 text-rose-700 dark:text-rose-400 font-medium min-w-0">
        <span class="relative flex h-2.5 w-2.5 shrink-0">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-rose-500"></span>
        </span>
        <span class="font-bold shrink-0">{{ 'OPERATING_HOURS.CURRENTLY_CLOSED' | translate }}</span>
        <span class="text-rose-600/70 dark:text-rose-400/60 hidden sm:inline shrink-0">•</span>
        <span class="text-rose-800 dark:text-rose-300 truncate">
          @if (settingsService.operatingStatus().messageKey === 'OPERATING_HOURS.OPENS_TODAY_AT') {
          {{ 'OPERATING_HOURS.OPENS_TODAY_AT' | translate : { time: settingsService.operatingStatus().opensAtTime } }}
          } @else if (settingsService.operatingStatus().messageKey === 'OPERATING_HOURS.OPENS_TOMORROW_AT') {
          {{ 'OPERATING_HOURS.OPENS_TOMORROW_AT' | translate : { time: settingsService.operatingStatus().opensAtTime } }}
          } @else if (settingsService.operatingStatus().messageKey === 'OPERATING_HOURS.OPENS_DAY_AT') {
          {{ 'OPERATING_HOURS.OPENS_DAY_AT' | translate : { day: settingsService.operatingStatus().nextOpenDay, time: settingsService.operatingStatus().opensAtTime } }}
          } @else {
          {{ 'OPERATING_HOURS.CLOSED_TODAY' | translate }}
          }
        </span>
      </div>
      <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-rose-500/15 text-rose-700 dark:text-rose-300 shrink-0">
        UTC0
      </span>
    </div>
  </div>
  }

  <!-- Global Cart Item Added Toast Pill -->
  @if (cartService.lastAddedItem(); as added) {
  <div
    class="fixed top-16 sm:top-20 left-1/2 z-50 animate-fly-pill max-w-sm w-[calc(100%-2rem)] sm:w-auto flex items-center justify-between gap-3 px-3.5 py-2.5 rounded-2xl bg-surface/95 backdrop-blur-md border border-border shadow-2xl transition-all pointer-events-auto">
    <div class="flex items-center gap-2.5 min-w-0">
      <div class="w-7 h-7 rounded-xl bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 flex items-center justify-center shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-xs font-bold text-main truncate max-w-[150px] sm:max-w-[200px]">
          {{ added.quantity > 1 ? (added.quantity + 'x ') : '' }}{{ getDisplayText(added.name) }}
        </span>
        <span class="text-[11px] text-emerald-600 dark:text-emerald-400 font-medium">
          {{ 'CART.ITEM_ADDED' | translate }}
        </span>
      </div>
    </div>

    <div class="flex items-center gap-1.5 shrink-0">
      <button type="button" (click)="cartService.openCart(); cartService.dismissLastAdded()"
        class="px-2.5 py-1 rounded-xl bg-primary text-primary-foreground text-xs font-bold shadow-xs hover:opacity-90 active:scale-95 transition-all cursor-pointer">
        {{ 'CART.VIEW_CART' | translate }}
      </button>
      <button type="button" (click)="cartService.dismissLastAdded()" class="w-6 h-6 rounded-full flex items-center justify-center text-muted hover:text-main cursor-pointer"
        aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-3.5 h-3.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
  }

  <main [class.pb-20]="waiterService.isTableCallAvailable()" [class.sm:pb-24]="waiterService.isTableCallAvailable()">
    <router-outlet />
  </main>
  <app-options-modal />
  <app-cart-modal />
  <app-order-status-modal />
  <app-table-switch-modal />
  <app-table-actions />
</div>